import { useEffect, useRef } from 'react';

import { shouldSkipAutoSelect } from '../utils/autoSelect';

import type { UseAutoSelectSingleGoalName } from './types/useAutoSelectSingleGoalName';

export const useAutoSelectSingleGoalName: UseAutoSelectSingleGoalName = (params) => {
  const { singleGoalNameId, isEditing, currentGoalNameId, onUpdateField, goalNameFieldId } = params;

  const hasUserClearedGoalRef = useRef(false);
  const prevSingleGoalNameIdRef = useRef<number | string | undefined>(undefined);
  const hasAutoSelectedForCurrentSingleRef = useRef(false);

  useEffect(() => {
    if (singleGoalNameId == null) {
      prevSingleGoalNameIdRef.current = undefined;
      hasUserClearedGoalRef.current = false;
      hasAutoSelectedForCurrentSingleRef.current = false;
      return;
    }

    const singleOptionChanged = prevSingleGoalNameIdRef.current !== singleGoalNameId;

    if (singleOptionChanged) {
      prevSingleGoalNameIdRef.current = singleGoalNameId;
      hasUserClearedGoalRef.current = false;
      hasAutoSelectedForCurrentSingleRef.current = false;
    }

    if (
      shouldSkipAutoSelect({
        hasUserCleared: hasUserClearedGoalRef.current,
        isEditing,
        currentId: currentGoalNameId ?? undefined,
        singleId: singleGoalNameId,
        hasAutoSelectedForCurrent: hasAutoSelectedForCurrentSingleRef.current,
      })
    ) {
      return;
    }

    hasAutoSelectedForCurrentSingleRef.current = true;
    onUpdateField(goalNameFieldId, singleGoalNameId);
  }, [singleGoalNameId, isEditing, currentGoalNameId, onUpdateField, goalNameFieldId]);

  return {
    setUserClearedGoalName: () => {
      hasUserClearedGoalRef.current = true;
    },
  };
};
